





































































































import {
  Vue, Component, Prop, PropSync,
} from 'vue-property-decorator';
import moment from 'moment';
import { Settings } from '@compassdigital/foodworks.ts.sdk';
import UserModule from '@/store/modules/user';
import MarketUtil from '@/util/MarketUtil';
import UnitsUtil from '@/util/UnitUtil';
import Format from '@/util/Format';
import SystemModule from '@/store/modules/system';
import Searchfield from '@/components/Form/Searchfield/index.vue';
import DatepickerModal from '@/components/Modal/DatepickerModal/index.vue';

@Component({
  components: {
    Searchfield,
    DatepickerModal,
  },
})
export default class OnBoardingDropdown extends Vue {
  @PropSync('selectDays', {}) selectDay!: string;

  @PropSync('marketsArr', {}) marketItems!: any;

  @PropSync('marketSelected', {}) marketSelect!: any;

  public getCurrentDate = Format.getCurrentDate();

  private priorDateMonth = moment().subtract(1, 'months').format();

  private priorDateDays = moment().subtract(7, 'days').format();

  private priorDateYesterday = moment().subtract(1, 'day').format();

  private marketItemList: Settings[] = [];

  private marketCheck: string = '';

  private NextDate: string = '';

  private previousDate: string = '';

  private isTimeFrame: boolean = false;

  private timeFrameValue = '';

  public selectItemDays = [
    {
      text: 'Last 30 Days',
      value: this.priorDateMonth,
    },
    {
      text: 'Last 7 Days',
      value: this.priorDateDays,
    },
    {
      text: 'Yesterday',
      value: this.priorDateYesterday,
    },
    {
      text: 'Select Timeframe',
      value: this.timeFrameValue,
    },
  ];

  public selectedMenuItem: any = {};

  public mounted() {
    this.getMarkets();
    this.selectedMenuItem = this.getSelectedItem(this.selectDay);
  }

  public getSelectedItem(val: any) {
    return {
      ...this.selectItemDays
        .filter((el: any) => moment(el.value).format('YYYY-MM-DD') === moment(val).format('YYYY-MM-DD'))[0],
    };
  }

  public getDocumentDate(uploadDate: any) {
    return Format.getFomattedStats(uploadDate);
  }

  public onSelectDate(val: any) {
    this.previousDate = '';
    this.NextDate = '';
    this.selectedMenuItem = this.getSelectedItem(val);
    if (val === '') {
      this.isTimeFrame = !this.isTimeFrame;
    }

    if (val !== '') {
      this.selectDay = val;
      this.$emit('onChangeDate', this.selectDay);
    }
  }

  public async onChangeSelectDate(prevDate: string, nextDate: string) {
    this.selectDay = '';
    this.previousDate = prevDate;
    this.NextDate = nextDate;
    if (this.previousDate && this.NextDate) {
      this.$emit('customDate', this.previousDate, this.NextDate);
    }
  }

  public get accessFWUser() {
    if (UserModule.currentRole === 'fw_manager'
      || UserModule.currentRole === 'fw_admin') {
      return true;
    }
    return null;
  }

  public get selectedMarketItems() {
    if (this.marketSelect) {
      const filteredMarketItems = this.marketItems
        .filter((el: any) => (this.marketSelect as Array<string>).includes(el.value));
      return filteredMarketItems;
    }
    return null;
  }

  public async getMarkets() {
    const { markets }: any = SystemModule;
    const items = MarketUtil.getMappedMarkets(markets);
    (this.marketItemList) = Format.sortedItems(items);
  }

  get marketItemsFiltered() {
    const filterSearchUnits = UnitsUtil.searchUnitItems(
      (this.marketItemList as any), this.marketCheck,
    );
    return filterSearchUnits;
  }
}
